import React from 'react';
import Text from '../../../../shared/components/Text';
import { ILabel } from '../../../../shared/interfaces/labels';

function UserLabel(props: ILabel) {
  return <Text.Label>{props.children}</Text.Label>;
}

export default UserLabel;
